import React from "react";

import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";

export default function StartTimerIcon(props) {
  return (
    <Svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M20.6375 0.4875C19.9875 -0.1625 19.0125 -0.1625 18.3625 0.4875C17.7125 1.1375 17.7125 2.1125 18.3625 2.7625L19.6625 4.0625L18.2 5.525C16.25 4.0625 13.975 3.25 11.375 3.25C5.0375 3.25 0 8.2875 0 14.625C0 20.9625 5.0375 26 11.375 26C17.7125 26 22.75 20.9625 22.75 14.625C22.75 12.025 21.9375 9.75 20.475 7.8L21.9375 6.3375L23.2375 7.6375C23.5625 7.9625 23.8875 8.125 24.375 8.125C24.8625 8.125 25.1875 7.9625 25.5125 7.6375C26.1625 6.9875 26.1625 6.0125 25.5125 5.3625L20.6375 0.4875ZM11.375 22.75C6.825 22.75 3.25 19.175 3.25 14.625C3.25 10.075 6.825 6.5 11.375 6.5C15.925 6.5 19.5 10.075 19.5 14.625C19.5 19.175 15.925 22.75 11.375 22.75Z"
        fill="url(#paint0_linear_12921_147146)"
      />
      <Path
        d="M13 9.75H9.75V16.25H16.25V13H13V9.75Z"
        fill="url(#paint1_linear_12921_147146)"
      />
      <Defs>
        <LinearGradient
          id="paint0_linear_12921_147146"
          x1="-7.2467e-07"
          y1="5.63855"
          x2="12.5157"
          y2="31.212"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#05858A" />
          <Stop offset="1" stop-color="#2AE8CB" />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear_12921_147146"
          x1="9.75"
          y1="11.1596"
          x2="12.8789"
          y2="17.553"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#05858A" />
          <Stop offset="1" stop-color="#2AE8CB" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
}
